<div class="class-wrapper">
  <app-status-messages
    [msgs]="msgs"
    [btnLabel]="btnLabel"
    [continueType]="continueType"
    (targetAction)="handleIncomingAction($event)"
  ></app-status-messages>
  <div class="modal-header text-center">
    <h4 class="modal-title w-100 font-weight-bold">{{ mode }} Experience</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="manageExperienceModal.hide()"
      id="close-modal-icon"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body m-3 p-0">
    <div class="row flex-add-form">
      <form
        class="text-center border border-light p-5 edit-form w-100"
        [formGroup]="experienceForm"
        (ngSubmit)="manageExperience()"
        autocomplete="off"
      >
        <div class="md-form mb-5 form-group">
          <input
            type="text"
            id="experience_name"
            formControlName="experience_name"
            class="form-control"
            mdbInput
          />
          <label for="experience_name">Experience Name</label>
        </div>
        <div class="md-form mb-5 form-group">
          <input
            type="text"
            id="experience_description"
            formControlName="experience_description"
            class="form-control"
            mdbInput
          />
          <label for="experience_description">Experience Description</label>
        </div>
        <div class="md-form">
          <input
            type="text"
            id="event_type"
            formControlName="experience_type"
            [ngModel]="searchText | async"
            (ngModelChange)="searchText.next($event)"
            [mdbAutoCompleter]="auto"
            class="completer-input form-control mdb-autocomplete"
            mdbInput
          />
          <label for="event_type">Add Event Type</label>
          <mdb-auto-completer
            #auto="mdbAutoCompleter"
            textNoResults="No Event Type Assiged"
          >
            <mdb-option *ngFor="let option of results | async" [value]="option">
              {{ option }}
            </mdb-option>
          </mdb-auto-completer>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button
      mdbBtn
      class="waves-light theme-action-button"
      mdbWavesEffect
      (click)="manageExperienceModal.hide()"
      id="close-modal-btn"
    >
      Close
    </button>
    <button
      mdbBtn
      class="waves-light theme-action-button"
      mdbWavesEffect
      (click)="manageExperience()"
      id="action-experience-btn"
    >
      {{ mode }} Experience
    </button>
  </div>
</div>
